module.exports = __webpack_public_path__ + "4467f385f599e894478e60058fcc5034.png";